import { render, staticRenderFns } from "./DialogChangeRequestSupport.vue?vue&type=template&id=520ff57e&scoped=true"
import script from "./DialogChangeRequestSupport.vue?vue&type=script&lang=js"
export * from "./DialogChangeRequestSupport.vue?vue&type=script&lang=js"
import style0 from "./DialogChangeRequestSupport.vue?vue&type=style&index=0&id=520ff57e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520ff57e",
  null
  
)

export default component.exports